export const CompanyThemes = {
  Active: 'Aktívna',
  Company: 'Spoločnosť',
  Metadata: 'Metadáta',
  Theme: 'Téma',
  Version: 'Verzia',
};
